import {XauditModel} from '../xaudit.model';

export class NoteGroupDescriptionModel {
  public ObjectId: string;
  public ObjectName: string;
  public ObjectDescription: string;
}
